import { useEffect } from "react";
import { useAuth as useQordelAuth } from "../../context/AuthContext";

const ROLE_MAP = { org_admin: "Administrator", manager: "Manager", user: "User", read_only: "Read Only" };

export function toNestixUser(session) {
  if (!session?.user) return null;
  const u = session.user;
  return { id: u.id, username: u.email, email: u.email, full_name: u.name, name: u.name, role: ROLE_MAP[u.role] || "User", modules: [], token: "session-cookie" };
}

export const useAuth = () => {
  const { session, logout } = useQordelAuth();
  const currentUser = toNestixUser(session);
  return { currentUser, isAuthenticated: !!currentUser, loading: session === null, login: async () => ({ success: false }), logout, hasModuleAccess: () => true };
};

export const AuthProvider = ({ children }) => children;

export function useNestixSessionSync() {
  const { session } = useQordelAuth();
  useEffect(() => {
    const u = toNestixUser(session);
    if (u) {
      localStorage.setItem("currentUser", JSON.stringify(u));
      localStorage.setItem("authVersion", "1.6");
    }
  }, [session]);
}
